import { StyleSheet } from 'aphrodite';
import COLORS from '../../../../library/colors';

const Color = require('color');

const styles = StyleSheet.create({
  root: {
    color: `${Color(COLORS.kgGreen).darken(0.08)}`,
    ':active': {
      background: `${Color(COLORS.kgGreen).lighten(1.24)}`,
      border: `1px solid ${Color(COLORS.kgGreen).lighten(0.12)}`,
    }
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/button/green-button/green-button-styles.js